"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var risklevelindicator_1 = require("./risklevelindicator");
var typestyle_1 = require("typestyle");
var RiskValue = function (props) {
    var riskvalue = null;
    if (props.show_explicit_value && props.value) {
        riskvalue = (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "RiskValueSeparator" }, "/"),
            React.createElement("div", { className: "RiskValueValue" }, props.value)));
    }
    var modifiers = props.show_explicit_value ? "RiskValues--explicit" : "RiskValues--simple";
    return (React.createElement("div", { className: (0, typestyle_1.classes)("RiskValues", modifiers) },
        React.createElement("div", { className: "RiskValueIndicator" },
            React.createElement(risklevelindicator_1.default, { risklevel: props.risklevel })),
        riskvalue));
};
exports.default = RiskValue;
